import { Container } from 'react-bootstrap';
import { format } from 'date-fns';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const currentYear = format(new Date(), 'yyyy');
  const location = useLocation();
  const isTermsRoute = location.pathname.includes('/TermsAndConditions');

  if (isTermsRoute) {
    return null;
  }

  return (
    <footer className="footer-dark">
      <Container>
        <div className="text-center">
          <p className="mb-0">
            &copy; {currentYear} Onbe, Inc. |{' '}
            <a
              href="/TermsAndConditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use
            </a>
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
